import * as React from "react";
import { ShopListItem } from "./model/ShopListSuccessResponse";
import { routes } from "../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { TableRow } from "../../components/table-components/TableRow";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { ButtonInternalLink } from "../../components/NewButtons";

interface Props {
  shop: ShopListItem;
}

export const ShopListRow: React.FC<Props> = ({ shop }) => {
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);
  const href = routes.shopEdit(organization, shop.id);

  return (
    <TableRow>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {shop.name}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {shop.title}
        </StyledText>
      </TableCellLink>
      <td>
        <div className="d-flex flex-row justify-content-end">
          <ButtonInternalLink
            to={routes.shopProductListForShop(organization, shop.id)}
          >
            Add products
          </ButtonInternalLink>
        </div>
      </td>
    </TableRow>
  );
};
